import React, { useEffect, useRef, useState } from "react";
import ModalClose from "../../assets/theme/icons/modal-close.png";

interface DrawerProps {
  children: React.ReactNode;
  onClose?: () => void;
  open: boolean;
  title?: string;
  showTitle?: boolean;
  showCloseIcon?: boolean;
  className?: any;
  style?: any;
  paymentDrawer?: boolean;
  widthIncreased?: boolean;
  customPadding?: boolean;
  avoidPageScroll?: boolean;
  fixYscrollCss?: boolean;
  customContentrTopPosition?: string
  outsideClickClose?: boolean;
  flexContent?: boolean;
}

const RightSideDrawer: React.FC<DrawerProps> = ({
  children,
  open = false,
  onClose = () => {},
  title = "",
  showTitle = true,
  showCloseIcon = true,
  className = "",
  style = {},
  paymentDrawer = false,
  widthIncreased = false,
  customPadding = false,
  avoidPageScroll = true,
  fixYscrollCss = false,
  customContentrTopPosition = "",
  outsideClickClose= true,
  flexContent = false,
}) => {
  console.log("Rendered at:", title, "-", new Date().toLocaleTimeString());
  const drawerRef = useRef<HTMLDivElement>(null);
  const [openConfirmDeleteAll, setOpenConfirmDeleteAll] = useState(false);

  // useThemeColor('#f7ebe9');

  useEffect(() => {
    if (open) {
      setOpenConfirmDeleteAll(open);
    }
  }, []);
  useEffect(() => {
    if (openConfirmDeleteAll) return;

    if (!open || !avoidPageScroll) return;

    let color = "#fae4dc";
    if (title == "Help Center") {
      color = "#fce7f3";
    } else if (title == "Profile") {
      color = "#fcc9b6";
    } else if (title == "Event Chat") {
      color = "#edceca";
    } else if (title == "Guest Attendance") {
      color = "#ffc6b0";
    }
    const metaTag = document.querySelector('meta[name="theme-color"]');
    if (metaTag) {
      metaTag?.setAttribute("content", color);
    }

    let scrollY = 0;

    const preventScroll = (e: TouchEvent) => {
      if (drawerRef.current && !drawerRef.current.contains(e.target as Node)) {
        e.preventDefault();
      }
    };

    if (open) {
      scrollY = window.scrollY;

      // Lock body scroll
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";

      // iOS Safari specific scroll lock
      //document.addEventListener("touchmove", preventScroll, { passive: false });
    } else {
      const top = document.body.style.top;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      document.body.style.width = "";

      window.scrollTo(0, parseInt(top || "0") * -1);
      document.removeEventListener("touchmove", preventScroll);
    }

    return () => {
      const top = document.body.style.top;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      document.body.style.width = "";

      window.scrollTo(0, parseInt(top || "0") * -1);
      document.removeEventListener("touchmove", preventScroll);
    };
  }, [open, avoidPageScroll]);

  // 📱 iOS Safari address bar hide trick
  useEffect(() => {
    if (
      open &&
      typeof window !== "undefined" &&
      /iPhone|iPad|iPod/i.test(navigator.userAgent)
    ) {
      window.scrollTo(0, 1); // Trigger initial scroll
      setTimeout(() => window.scrollTo(0, 0), 100); // Snap back
    }
  }, [open]);

  // 🖱️ Click outside to close
  const toggleDrawer = () => {
    const metaTag = document.querySelector('meta[name="theme-color"]');
    if (metaTag) {
      metaTag?.setAttribute("content", "#f7d2cd");
    }
    onClose();
  };

  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (target.closest(".Toastify__toast")) return;
    if (
      outsideClickClose &&
      drawerRef.current &&
      !drawerRef.current.contains(event.target as Node)
    ) {
      const metaTag = document.querySelector('meta[name="theme-color"]');
      if (metaTag) {
        metaTag?.setAttribute("content", "#f7d2cd");
      }
      onClose();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      ref={drawerRef}
      className={`${className} z-50 w-full md:w-[50vw] lg:w-[35vw] fixed top-0 bottom-0 right-0 flex flex-col transition-transform duration-700 transform ${
        open ? "translate-x-0" : "translate-x-full"
      } border-l-[1px] border-l-[#393939] bg-white overscroll-contain`}
      style={{ ...style }}
    >
      {/* Sticky Header */}
      <div className="shrink-0 flex relative items-center  px-3 lg:px-8 md:px-8">
        <div className="flex flex-row my-2">
          {showCloseIcon && (
            <img
              className={`
                ${open ? "flex" : "hidden"} 
                absolute 
                cursor-pointer 
                w-12 h-12 
                bg-[#FAF2F6] shadow-lg border border-white rounded-full z-50  
                md:left-[-25px] right-4
              `}
              onClick={toggleDrawer}
              src={ModalClose}
              alt="Close"
            />
          )}

          <div className="py-1">
            <span className="text-[#0F090B] font-[PINYADA-Beranda-Regular] flex-1 font-dm font-bold text-2xl leading-8 tracking-tighter text-left">
              {showTitle && title}
            </span>
          </div>
        </div>
      </div>

      {/* Scrollable Content */}
      <div
        className={`${
          customPadding ? "w-full" : "w-full px-3 lg:px-8 md:px-8"
        } ${customContentrTopPosition} ${
          fixYscrollCss
            ? "md:pb-24  flex-1 -webkit-overflow-scrolling-touch"
            : ""
        } ${flexContent ? "flex-1 min-h-0 flex flex-col" : ""}`}
        style={{}}
      >
        {children}
      </div>
    </div>
  );
};

export default RightSideDrawer;
